import type * as React from "react";
export const MyplannPieChartIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width={64}
			height={64}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity={0.3}
				d="M32 0C39.6812 9.15969e-08 47.106 2.76291 52.9187 7.78416C58.7314 12.8054 62.544 19.75 63.6603 27.3496L52.6164 28.9718C51.8895 24.0231 49.4068 19.501 45.6217 16.2313C41.8367 12.9616 37.0018 11.1624 32 11.1624V0Z"
				fill="#D9D9D9"
			/>
			<path
				opacity={0.3}
				d="M35.3171 35.8267V38.2273H28.6836V35.8267H35.3171Z"
				fill="#64748B"
			/>
			<path
				opacity={0.3}
				d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM11.1624 32C11.1624 43.5083 20.4917 52.8376 32 52.8376C43.5083 52.8376 52.8376 43.5083 52.8376 32C52.8376 20.4917 43.5083 11.1624 32 11.1624C20.4917 11.1624 11.1624 20.4917 11.1624 32Z"
				fill="white"
			/>
		</svg>
	);
};
